<template>
  <div class="background">
    <div
      class="background__image"
      :style="{
        backgroundImage: `url(${$baseUrl}images/bg.png) `,
        transform: `scale(${(landingIndex + 1) * 0.05 + 1})`,
      }"
    ></div>

    <div
      class="background--border"
      v-if="(landingIndex == -1 && !isModalOpen) || isMenuOpen || isModalOpen"
      :key="'border'"
    ></div>
    <div
      :class="['background__lines', { firstLine: landingIndex >= -1 }]"
      :key="'lines'"
    >
      <div
        class="background__lines--line"
        v-for="index in NLines"
        :key="index"
      ></div>
    </div>
    <div
      class="background--img"
      v-if="landingIndex == -1 || isMenuOpen || isModalOpen"
      :key="'main'"
      :style="{
        backgroundImage: 'var(--main-gradient)',
      }"
    />
    <transition name="fade">
      <div
        class="background--img"
        v-if="landingIndex >= 0 && !isMenuOpen && !isModalOpen"
        :key="backGroundColor"
        :style="{
          backgroundImage: backGroundColor,
        }"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import bgColor from "@/mixins/bgColor";
export default {
  name: "Background",
  mixins: [bgColor],
  data() {
    return {
      NLines: 4,
    };
  },
  computed: {
    ...mapGetters({
      landingIndex: "scroller/landingIndex",
      _color: "ui/sourceColor",

      isMenuOpen: "ui/isMenuOpen",
      isModalOpen: "ui/isModalOpen",
    }),
  },
};
</script>

<style lang="scss" scoped>
.background {
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform-origin: 0 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    transition: transform 1s ease;
  }

  &--border {
    width: toRem(6);
    height: 100vh;
    background-color: $primary-yellow;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
  }

  &__lines {
    position: absolute;
    top: 0;
    left: toRem($landing-side-WIDTH);
    width: 100vw;
    height: 100vh;
    z-index: 2;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    &.firstLine {
      border-left: $white-border;
    }

    &--line {
      border-right: $white-border;
      width: $background-lines-WIDTH;
      height: 100vh;
    }
  }
  &--img {
    position: absolute;
    top: 0;

    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    mix-blend-mode: multiply;
    transition: all 1s ease;
    background-position: center;
    background-size: 101vw;
  }
}

.mobile {
  .background {
    &__lines {
      left: 0;
      justify-content: space-between;
      padding-left: $header-width-mobile;
      padding-right: $header-width-mobile;
      &--line {
        &:last-child {
          display: none;
        }
        width: $white-border;
      }
    }
    &--border {
      display: none;
    }
  }
}
</style>
